export const CaseStudies = (() => {
  "use strict";

  function init() {
    layout();

    $(".posts").slick({
      infinite: true,
      dots: false,
      arrows: false,
      speed: 5000,
      cssEase: "linear",
      autoplay: true,
      autoplaySpeed: 0,
      slide: "div",
      focusOnSelect: true,
      pauseOnHover: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
          },
        },
      ],
    });

    var $filter = $(".case-study-filter");
    var $postFilter = $(".case-study__cats span");

    if ($('.case-studies__filtering').length) {
     
      $filter.on("click", function (e) {
        $(this).addClass("active").siblings().removeClass("active");
        layout();
      });

      $postFilter.on("click", function (e) {
        console.log('click');
          var $catTerm = $(this).attr("data-cat");
          console.log($catTerm);
          $('.case-study-filter[data-term*="' + $catTerm + '"]').trigger("click");
      });

    } else {
        console.log('no filter');
       $(".case-studies .case-study").show();
       $(".case-study:visible:odd").each(function () {
        $(this).css("margin-top", "140px");
      });
    }
  
  }

  function layout() {
    var $caseStudy = $(".case-studies .case-study");
    var term = $(".case-studies__filtering .active").attr("data-term");

    $caseStudy.removeAttr("style");

    if (term == "") {
      $caseStudy.show();

    } else {
      $caseStudy.hide();
      $('.case-study[data-terms*="' + term + '"]').show();
    }

    $(".case-study:visible:odd").each(function () {
      $(this).css("margin-top", "140px");
    });

    $(".case-study:visible").eq(0).addClass('animated');
    $(".case-study:visible").eq(1).addClass('animated');
  }

  return {
    init: init,
    name: "case-studies",
  };
})();
